<div [hidden]="isInitialLoading">
    <div class="mb-3">
        <span class="me-2">Days to show</span>
        @for (option of [30, 60, 90, 180]; track option) {
            <button class="btn btn-sm me-1" [class.btn-primary]="days === option" [class.btn-outline-primary]="days !== option" (click)="setDays(option)">
                {{ option }}
            </button>
        }
    </div>
    @if (loadError) {
        <div class="alert alert-warning">The dashboard could not be loaded.</div>
    }
    <div class="row g-3">
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Due inspections</div><div class="fs-3">{{ metrics.dueInspections }}</div></div></div></div>
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Missed inspections</div><div class="fs-3">{{ metrics.missedInspections }}</div></div></div></div>
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Open action items</div><div class="fs-3">{{ metrics.openActionItems }}</div><div class="small text-danger">{{ metrics.lateActionItems }} late</div></div></div></div>
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Weather events</div><div class="fs-3">{{ metrics.recentWeatherEvents }}</div></div></div></div>
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Permits expiring</div><div class="fs-3">{{ metrics.permitsExpiring }}</div><div class="small">{{ metrics.permitsExpired }} expired</div></div></div></div>
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Missing permit</div><div class="fs-3">{{ metrics.sitesMissingPermit }}</div></div></div></div>
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Missing plan</div><div class="fs-3">{{ metrics.sitesMissingPlan }}</div></div></div></div>
        <div class="col-md-3"><div class="card"><div class="card-body"><div class="text-muted">Missing map</div><div class="fs-3">{{ metrics.sitesMissingMap }}</div></div></div></div>
    </div>
    <ul class="list-group mt-3">
        @for (row of metrics.rows; track row.siteId + row.kind + row.detail) {
            <li class="list-group-item d-flex justify-content-between">
                <a [routerLink]="['/field-tools/swppp/site', row.siteId]">{{ row.title }}</a>
                <span>{{ row.detail }}</span>
            </li>
        }
    </ul>
</div>
